import React from "react";
import { FrontPage } from "./TableFlyer";

// Standalone, chrome-free Front page at full 8.5×11 (816×1056) resolution.
// Open this URL and right-click the image → "Save image as…" or screenshot it.
export default function TableFlyerFront() {
  return (
    <div
      data-testid="tableflyer-front-standalone"
      className="min-h-screen w-full bg-black flex items-start justify-center"
      style={{ padding: 0 }}
    >
      <FrontPage />
    </div>
  );
}
